var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20903"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5356",
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F3223C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Curved/Send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.433 25.567C24.433 25.567 10.0595 22.5936 15.0544 19.7102C19.2694 17.2772 33.7957 13.0941 35.8251 14.1749C36.9059 16.2044 32.7227 30.7306 30.2897 34.9456C27.4064 39.9405 24.433 25.567 24.433 25.567Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M24.4331 25.5669L35.8252 14.1748",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.3be360431e5f26cbec175cbcaf618afc.svg";
export { ForwardRef as ReactComponent };